import React from 'react';
import PropTypes from 'prop-types';
import OfferListItem from './OfferListItem';
import { OfferListWrapper } from './OfferListStyles';

const OfferList = ({ offers, fieldsToShow, onEditLink }) => (
  <OfferListWrapper container>
    {offers.map((n, idx) => {
      return <OfferListItem key={n.documentId} item={n} index={idx} onEditLink={onEditLink} fieldsToShow={fieldsToShow} />;
    })}
  </OfferListWrapper>
);

OfferList.propTypes = {
  offers: PropTypes.array.isRequired,
  fieldsToShow: PropTypes.array.isRequired,
  onEditLink: PropTypes.func.isRequired
};

export default OfferList;
